import clsx from 'clsx'
import React from 'react'

import { logoLayoutClass, logoMarkClassName } from './logoTheme'

function urlPathLooksLikeSvg(url: string): boolean {
  const base = url.split('?')[0]?.split('#')[0]?.toLowerCase() ?? ''
  return base.endsWith('.svg')
}

const FALLBACK_LOGO_SRC =
  'https://raw.githubusercontent.com/payloadcms/payload/main/packages/ui/src/assets/payload-logo-light.svg'

interface Props {
  className?: string
  /** Classes do CMS (`getSiteLogoInvertClass`) — inversão preto/branco por tema global. */
  invertClassName?: string | null
  loading?: 'lazy' | 'eager'
  priority?: 'auto' | 'high' | 'low'
  /** URL do Media (ex. /api/media/file/...) ou URL absoluta; se vazio, usa logo Payload template. */
  src?: string | null
  alt?: string | null
  /** Largura em px (Identidade do site); altura automática; `max-width: 100%` para ecrãs pequenos. */
  widthPx?: number | null
}

export const Logo = (props: Props) => {
  const {
    loading: loadingFromProps,
    priority: priorityFromProps,
    className,
    invertClassName,
    src,
    alt,
    widthPx,
  } = props

  const loading = loadingFromProps || 'lazy'
  const priority = priorityFromProps || 'low'
  const customSrc = src?.trim()
  const resolvedSrc = customSrc || FALLBACK_LOGO_SRC
  const resolvedAlt = alt?.trim() || 'Logo'
  const hasCustomBrandMark = Boolean(customSrc)
  const srcIsVector = urlPathLooksLikeSvg(resolvedSrc)
  const w =
    widthPx != null && Number.isFinite(widthPx) && widthPx > 0 ? Math.round(widthPx) : null
  const sizeStyle = w
    ? ({ width: w, maxWidth: '100%', height: 'auto' } as const)
    : undefined

  return (
    /* eslint-disable @next/next/no-img-element */
    <img
      alt={resolvedAlt}
      width={w ? undefined : 193}
      height={w ? undefined : 34}
      style={sizeStyle}
      loading={loading}
      fetchPriority={priority}
      decoding="async"
      className={clsx(
        logoLayoutClass,
        logoMarkClassName(hasCustomBrandMark, srcIsVector),
        invertClassName?.trim(),
        className,
      )}
      src={resolvedSrc}
    />
  )
}
